import { useContext } from "react"
import useBreakpoint from "~/hooks/useBreakpoint"
import { AdminContext } from "~/contexts/AdminContext"
import Spinner from "~/components/ui/Spinner"
import ReservationsSummarySection from "~/components/Admin/Reports/ReportsReservations/ReservationsSummarySection"
import ReservationsCardList from "~/components/Admin/Reports/ReportsReservations/ReservationsCardList"
import ReservationsTable from "~/components/Admin/Reports/ReportsReservations/ReservationsTable"

export type iReservationReport = {
  arrival: Date
  departure: Date
  created_at: Date
  name: string
  site: string
  owed: number
  paid: number
  taxes: number
  credit_card_fees_collected: number
  service_fee: number
  total_collected: number
  stripe_fee: number
  net_received: number
  status: string
  payment_mode: string
  duration: string
  email: string
  phone: string
  notes: string
  site_type: string
  adults: number
  kids: number
  discount_type: string
}

export type iReservationSummaryReport = {
  amount_of_reservations: number
  total_net_received: number
  taxes_collected: number
}

interface ComponentProps {
  data: iReservationReport[]
  summary: iReservationSummaryReport
  isLoading: boolean
}

const ReportsReservations = (props: ComponentProps) => {
  const { camp, campingStyles } = useContext(AdminContext)
  const isMedium = useBreakpoint("(max-width: 768px)")

  const isCollectingTax =
    campingStyles?.map((style) => parseFloat(style.tax_rate) > 0).includes(true) || parseFloat(camp.tax_rate) > 0
  const isCollectingCreditCardFee = camp.camping_styles?.map((style) => style.credit_card_rate > 0).includes(true)

  return (
    <div className="relative w-full">
      {props.isLoading && (
        <div className="z-20 absolute top-0 bg-transparent w-full h-full opacity-70 flex items-start justify-center">
          <Spinner size={12} />
        </div>
      )}

      <div className="flex flex-col w-full " style={{ height: "calc(100vh - 290px)", minHeight: "400px" }}>
        <ReservationsSummarySection
          summary={props.summary}
          camp={camp}
          isMobile={isMedium}
          isCollectingTax={isCollectingTax}
        />

        <div
          className="overflow-auto flex-grow relative border-y border-gray-100 scrollbar-thin"
          style={{
            scrollbarWidth: (isMedium && "none") || "auto",
          }}
        >
          {isMedium ? (
            <ReservationsCardList
              data={props.data}
              camp={camp}
              isCollectingTax={isCollectingTax}
              isCollectingCreditCardFee={isCollectingCreditCardFee}
            />
          ) : (
            <ReservationsTable
              data={props.data}
              camp={camp}
              isCollectingTax={isCollectingTax}
              isCollectingCreditCardFee={isCollectingCreditCardFee}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ReportsReservations
